import FJObjectEraseLeft from '../view/FJObjectEraseLeft';
import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useMemo } from 'react';
import FJUtil from '../../../../util/FJUtil';
import FJConstant from '../../../../constants/FJConstant';

const FJObjectEraseLeftContainer = () => {
    useLocalStore();

    const isNotImage = useSelector(state => state.objectErase.inputImageInfo === null);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const isDisabled = useMemo(() => {
        return FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    }, [taskStatus]);

    return <FJObjectEraseLeft isNotImage={isNotImage} isDisabled={isDisabled} taskStatus={taskStatus} />;
};

export default FJObjectEraseLeftContainer;
